module.exports = __webpack_public_path__ + "static/media/28DGC2.9f2ec7e2.jpg";